import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  BoardSearchResult,
  CalendarBox,
  CalendarIcon,
  ColSpan0,
  ColSpan1,
  ColTitle,
  CustomDatePicker,
  DateContainer,
  DeleteButton,
  GraySearchButton,
  RangePicker,
  RowSpan,
  Span1,
  ColSpan4, ColSpan2, mainColor, ChartTooltip, ChartContainer
} from "../../assets/GlobalStyles";
import ReportSelect from "../../components/common/ReportSelect";
import ko from "date-fns/locale/ko";
import {HorizontalRule} from "../../components/common/Common";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {
  getLastDay,
  getLastMonth,
  getLastNinetyDay,
  getLastThirtyDay,
  getLastWeekDay,
  getThisMonth,
  getToDay
} from "../../common/DateUtils";
import Table from "../../components/table";
import {
  deleteCustomReportsAxios,
  retrieveCommonReportsDetail, retrieveCommonReportsDetailByAdverCampId,
  retrieveCustomReportsDetail
} from "../../services/reports/ReportsAxios";
import {useAtom, useAtomValue} from "jotai";
import {reportsInfoAtom, tokenResultAtom} from "../login/entity/Common";
import {useLocation, useNavigate} from "react-router-dom";
import {dateFormat, decimalFormat, moneyToFixedFormat, numberToFixedFormat} from "../../common/StringUtils";
import {deviceType, productType, targetingType} from "../dash_board/entity/Common";
import {
  deleteCustomReportsAdminAxios,
  retrieveCommonReportsAdminDetail,
  retrieveCommonReportsAdminDetailByAdverCampId,
  retrieveCommonReportsAdminDetailByAdverId,
  retrieveCustomReportsAdminDetail
} from "../../services/reports/ReportsAdminAxios";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment";
import {light} from "../../assets/theme";
import styled, {css} from "styled-components";
import PlatformSectionHeader from "../platform_manage/PlatformSectionHeader";
import {ReportCalendarContainer, ReportConditionActions, ReportConditionSummary} from "./ReportSharedLayout";
import {
  summaryReducer,
  summaryReportReducer
} from "../dash_board/entity/Campaign";
import {lockedRows} from "./ReportsCampaign";
import {lockedReportRows} from "./entity/common";
import {
  selInventoryByAdminCampaign,
  selKeywordAdminCampaign,
  selKeywordCampaign,
  selKeywordUser
} from "../../services/Platform/ManageUserAxios";
import {ResponsiveLine} from "@nivo/line";
import {
  chartDataAtom,
  chartReportDataAtom,
  commonProperties
} from "../dash_board/entity/Chart";
import {ResponsiveBar} from "@nivo/bar";
import {KPI_CHART_COLORS} from "../../common/ChartColors";

const reportChartMetrics = {
  exposureCount: {
    color: KPI_CHART_COLORS.exposureCount,
    description: '선택 기간의 일자별 광고 노출 횟수'
  },
  costAmount: {
    color: KPI_CHART_COLORS.costAmount,
    description: '선택 기간의 일자별 광고 집행 비용'
  }
};

function weekNumberByMonth(dateFormat) {
  const inputDate = new Date(dateFormat);

  // 인풋의 년, 월
  let year = inputDate.getFullYear();
  let month = inputDate.getMonth() + 1;

  // 목요일 기준 주차 구하기
  const weekNumberByThurFnc = (paramDate) => {

    const year = paramDate.getFullYear();
    const month = paramDate.getMonth();
    const date = paramDate.getDate();

    // 인풋한 달의 첫 날과 마지막 날의 요일
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month+1, 0);
    const firstDayOfWeek = firstDate.getDay() === 0 ? 7 : firstDate.getDay();
    const lastDayOfweek = lastDate.getDay();

    // 인풋한 달의 마지막 일
    const lastDay = lastDate.getDate();

    // 첫 날의 요일이 금, 토, 일요일 이라면 true
    const firstWeekCheck = firstDayOfWeek === 5 || firstDayOfWeek === 6 || firstDayOfWeek === 7;
    // 마지막 날의 요일이 월, 화, 수라면 true
    const lastWeekCheck = lastDayOfweek === 1 || lastDayOfweek === 2 || lastDayOfweek === 3;

    // 해당 달이 총 몇주까지 있는지
    const lastWeekNo = Math.ceil((firstDayOfWeek - 1 + lastDay) / 7);

    // 날짜 기준으로 몇주차 인지
    let weekNo = Math.ceil((firstDayOfWeek - 1 + date) / 7);

    // 인풋한 날짜가 첫 주에 있고 첫 날이 월, 화, 수로 시작한다면 'prev'(전달 마지막 주)
    if(weekNo === 1 && firstWeekCheck) weekNo = 'prev';
    // 인풋한 날짜가 마지막 주에 있고 마지막 날이 월, 화, 수로 끝난다면 'next'(다음달 첫 주)
    else if(weekNo === lastWeekNo && lastWeekCheck) weekNo = 'next';
    // 인풋한 날짜의 첫 주는 아니지만 첫날이 월, 화 수로 시작하면 -1;
    else if(firstWeekCheck) weekNo = weekNo -1;

    return weekNo;
  };

  // 목요일 기준의 주차
  let weekNo = weekNumberByThurFnc(inputDate);

  // 이전달의 마지막 주차일 떄
  if(weekNo === 'prev') {
    // 이전 달의 마지막날
    const afterDate = new Date(year, month-1, 0);
    year = month === 1 ? year - 1 : year;
    month = month === 1 ? 12 : month - 1;
    weekNo = weekNumberByThurFnc(afterDate);
  }
  // 다음달의 첫 주차일 때
  if(weekNo === 'next') {
    year = month === 12 ? year + 1 : year;
    month = month === 12 ? 1 : month + 1;
    weekNo = 1;
  }

  return {year, month, weekNo};
}

function FilterCheckboxDropdown({options, selectedValues, onChange, disabled, itemName, searchPlaceholder}) {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const containerRef = useRef(null);
  const campaignOptions = options.filter(option => option.value !== '');
  const selectedOptions = campaignOptions.filter(option => selectedValues.includes(option.value));
  const filteredOptions = campaignOptions.filter(option => option.label.toLowerCase().includes(keyword.trim().toLowerCase()));
  const isAllSelected = campaignOptions.length > 0 && selectedOptions.length === campaignOptions.length;
  const displayValue = selectedOptions.length === 0
    ? '전체'
    : selectedOptions.length === 1
      ? selectedOptions[0].label
      : `${selectedOptions.length}개 ${itemName} 선택`;

  useEffect(() => {
    const handleOutsideClick = event => {
      if(containerRef.current && !containerRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const toggleCampaign = option => {
    const nextValues = selectedValues.includes(option.value)
      ? selectedValues.filter(value => value !== option.value)
      : [...selectedValues, option.value];
    onChange(campaignOptions.filter(item => nextValues.includes(item.value)));
  };

  const toggleAll = () => onChange(isAllSelected ? [] : campaignOptions);

  return <FilterCheckboxContainer ref={containerRef}>
    <FilterCheckboxTrigger
      type="button"
      disabled={disabled}
      $open={open}
      onClick={() => !disabled && setOpen(current => !current)}
      aria-haspopup="listbox"
      aria-expanded={open}
    >
      <span>{displayValue}</span>
      <FilterDropdownArrow $open={open}>⌄</FilterDropdownArrow>
    </FilterCheckboxTrigger>
    {open && <FilterCheckboxMenu>
      <FilterSearchInput
        value={keyword}
        onChange={event => setKeyword(event.target.value)}
        placeholder={searchPlaceholder}
        autoFocus
      />
      <FilterCheckboxOption as="button" type="button" onClick={toggleAll}>
        <input type="checkbox" checked={isAllSelected} readOnly/>
        <strong>전체 선택</strong>
      </FilterCheckboxOption>
      <FilterCheckboxList role="listbox" aria-multiselectable="true">
        {filteredOptions.map(option => <FilterCheckboxOption
          as="button"
          type="button"
          key={option.value}
          onClick={() => toggleCampaign(option)}
          role="option"
          aria-selected={selectedValues.includes(option.value)}
        >
          <input type="checkbox" checked={selectedValues.includes(option.value)} readOnly/>
          <span>{option.label}</span>
        </FilterCheckboxOption>)}
        {!filteredOptions.length && <FilterEmptyOption>검색 결과가 없습니다.</FilterEmptyOption>}
      </FilterCheckboxList>
    </FilterCheckboxMenu>}
  </FilterCheckboxContainer>;
}

const defaultColumn = {
  'BY_DAILY': {
    name: 'statisticsDate',
    header: '일별',
    type: 'number',
    sortable: true,
    textAlign: 'center',
    render: ({cellProps}) => {
      return <span><p>{dateFormat(cellProps.data.statisticsDate, 'yyyy년 MM월 DD일')}</p></span>
    },
    flex: 1
  },
  'BY_WEEKLY': {
    name: 'statisticsStartDate',
    header: '주별',
    textAlign: 'center',
    render: ({cellProps}) => {
      const weeks = weekNumberByMonth(cellProps.data.statisticsStartDate)
      return <span><p>{moment(cellProps.data.statisticsStartDate).format('MM월 DD일')}</p><p
        style={{color: '#999'}}>({weeks.month}월 {weeks.weekNo}주차)</p></span>
    },
    flex: 1
  },
  'BY_MONTHLY': {
    name: 'statisticsDate',
    header: '월별',
    textAlign: 'center',
    render: ({cellProps}) => {
      return <span><p>{dateFormat(cellProps.data.statisticsStartDate, 'yyyy년 MM월')} </p></span>
    },
    flex: 1
  },
  'adverName': {
    name: 'adverName',
    header: '광고주명',
    textAlign: 'center',
    render: (props) => {
      return <span>{props.value}</span>
    },
    flex: 1
  },
  'campaignName': {
    name: 'campaignName',
    header: '캠페인명',
    textAlign: 'center',
    flex: 1
  },
  'productName': {
    name: 'productType',
    header: '상품명',
    textAlign: 'center',
    render: ({value}) => {
      return <span>{productType.find(item => item.value === value)?.label}</span>
    },
    flex: 1
  },
  'targetingName': {
    name: 'targetingType',
    header: '타겟팅',
    textAlign: 'center',
    render: ({value}) => {
      return <span>{targetingType.find(item => item.value === value)?.label}</span>
    },
    flex: 1
  },
  'clickRate': {
    textAlign: 'center',
    render: (props) => {
      const clickRate = (props.data.validClickCount / props.data.exposureCount) * 100
      return <span className={'pct'}>{!isNaN(clickRate) ? numberToFixedFormat(clickRate) : 0}</span>
    },
    flex: 1
  },
  'cpc': {
    textAlign: 'center',
    render: (props) => {
      const cpc = props.data.costAmount / props.data.validClickCount
      return <span className={'won'}>{!isNaN(cpc) ? moneyToFixedFormat(cpc) : 0}</span>
    },
    flex: 1
  },
  'conversionRate': {
    textAlign: 'center',
    render: (props) => {
      const conversionRate = (props.data.conversionCount / props.data.totalClickCount) * 100
      return <span className={'pct'}>{!isNaN(conversionRate) ? numberToFixedFormat(conversionRate) : 0}</span>
    },
    flex: 1
  },
  'conversionPrice': {
    textAlign: 'center',
    render: (props) => {
      const costPerConversion = props.data.costAmount / props.data.conversionCount
      return <span className={'won'}>{!isNaN(costPerConversion) ? moneyToFixedFormat(costPerConversion) : 0}</span>
    },
    flex: 1
  },
  'amountPurchasedAvg': {
    textAlign: 'center',
    render: (props) => {
      const amountPurchased = (props.data.costAmount / props.data.conversionCount)
      return <span className={'won'}>{!isNaN(amountPurchased) ? moneyToFixedFormat(amountPurchased) : 0}</span>
    },
    flex: 1
  },
  'sessionConversionRoas': {
    textAlign: 'center',
    render: (props) => {
      const sessionRoas = (props.data.sessionConversionAmount / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(sessionRoas) ? numberToFixedFormat(sessionRoas) : 0}</span>
    },
    flex: 1
  },
  'directConversionRoas': {
    textAlign: 'center',
    render: (props) => {
      const directRoas = (props.data.directConversionAmount / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(directRoas) ? numberToFixedFormat(directRoas) : 0}</span>
    },
    flex: 1
  },
  'roas': {
    textAlign: 'center',
    render: (props) => {
      const roas = ((props.data.sessionConversionAmount + props.data.exposureConversionAmount + props.data.directConversionAmount) / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(roas) ? numberToFixedFormat(roas) : 0}</span>
    },
    flex: 1
  },
  'exposureConversionRoas': {
    textAlign: 'center',
    render: (props) => {
      const exposureRoas = (props.data.exposureConversionAmount / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(exposureRoas) ? numberToFixedFormat(exposureRoas) : 0}</span>
    },
    flex: 1
  },
  'eCpm': {
    header: 'CPV',
    type: 'number',
    sortable: false,
    textAlign: 'center',
    render: (props) => {
      const ecpm = (props.data.costAmount / props.data.exposureCount) * 1000
      return <span className={'won'} style={{color: '#5c5'}}>{!isNaN(ecpm) ? moneyToFixedFormat(ecpm) : 0}</span>
    },
    flex: 1
  },
  "exposureCount": {
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "countByAdvertise": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "validClickCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "totalExposureCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "conversionCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "directConversionAmount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span className={'won'}>{moneyToFixedFormat(value)}</span>
    },
    flex: 1
  },
  "sessionConversionAmount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span className={'won'}>{moneyToFixedFormat(value)}</span>
    },
    flex: 1
  },
  "totalClickCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "exposureConversionAmount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span className={'won'}>{moneyToFixedFormat(value)}</span>
    },
    flex: 1
  },
  "costAmount": {
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span className={'won'} style={{color: '#c55'}}>{decimalFormat(value)}</span>
    },
    flex: 1
  }
}

export default function ReportsPeriod() {
  const [isConditionOpen, setIsConditionOpen] = useState(false)
  const [downloadTrigger, setDownloadTrigger] = useState(0)
  const mainColor = light.color.topicColor;
  const [searchCondition, setSearchCondition] = useState({
    pageSize: 31,
    currentPage: 1,
    searchStartDate: getThisMonth().startDay,
    searchEndDate: getToDay(),
    productType: null,
    deviceType: null,
    inventoryId: null
  })
  const [adverList, setAdverList] = useState([{
    key: 0,
    value: '',
    label: '전체'
  }]);
  const [campaignList, setCampaignList] = useState([{
    key: 0,
    value: '',
    label: '전체'
  }]);
  const [inventoryList, setInventoryList] = useState([{
    key: 0,
    value: '',
    label: '전체'
  }]);
  const [dateActive,setDateActive] = useState('thisMonth');
  const [dateRange, setDateRange] = useState([ new Date(getThisMonth().startDay), new Date(getToDay())]);
  const [startDate, endDate] = dateRange;
  const tokenResult = useAtomValue(tokenResultAtom);
  const [campaignColumn, setCampaignColumn] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [selectedAdver, setSelectedAdver] = useState('');
  const [selectedAdverCamp, setSelectedAdverCamp] = useState([]);
  const [selectedInventory, setSelectedInventory] = useState([]);
  const handleResetReports = () => {
    setSelectedAdver(''); setSelectedAdverCamp([]); setSelectedInventory([]);
    setCampaignList([{key:0,value:'',label:'전체'}]);
    setInventoryList([{key:0,value:'',label:'전체'}]);
    setDateActive('thisMonth');
    setDateRange([new Date(getThisMonth().startDay), new Date(getToDay())]);
    setSearchCondition(current => ({...current,currentPage:1,searchStartDate:getThisMonth().startDay,searchEndDate:getToDay(),productType:null,deviceType:null,inventoryId:null}));
  };
  const [reportSettingInfo, setReportSettingInfo] = useState({});
  const navigate = useNavigate();
  const [chartList, setChartList] = useState([]);
  const [chartData, setChartData] = useState(() => ({
    ...chartReportDataAtom,
    exposureCount: {...chartReportDataAtom.exposureCount},
    costAmount: {...chartReportDataAtom.costAmount}
  }));
  const [chartDataInfo, setChartDataInfo] = useState([])
  const [reportsInfo, setReportsInfo] = useAtom(reportsInfoAtom);

  useEffect(() => {
    if(reportsInfo.id === null) return navigate('/board/reports')
    if(tokenResult?.role !== "NORMAL") {
      retrieveCommonReportsAdminDetail(tokenResult?.id, searchCondition, 'period').then(response => {
        if(response){
          let newObject = response?.adminSetting.groupByPeriod !== 'NONE' ? [defaultColumn[reportsInfo.groupBy]].concat(response.headers) : [].concat(response.headers)
          newObject.map((item, key) => {
            Object.assign(newObject[key], defaultColumn[item.name])
            return null
          })
          setCampaignColumn(newObject)
          setCampaignData(response?.pagingCommonResponse.content)
          setReportSettingInfo(response?.adminSetting)
        }
      })
    } else {
      retrieveCommonReportsDetail(tokenResult?.id, searchCondition, 'period').then(response => {
        if(response) {
          let newObject =  response?.userSetting.groupByPeriod !== 'NONE' ? [defaultColumn[reportsInfo.groupBy]].concat(response.headers) : [].concat(response.headers)
          newObject.map((item, key) => {
            Object.assign(newObject[key], defaultColumn[item.name])
            return null
          })
          setCampaignColumn(newObject)
          setCampaignData(response.pagingCommonResponse.content)
          setReportSettingInfo(response.userSetting)
        }
      })
    }
    return () => {
      setDateActive('thisMonth')
      setDateRange([ new Date(getThisMonth().startDay), new Date(getToDay())])
      setSearchCondition({
        pageSize: 31,
        currentPage: 1,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getToDay(),
        productType: null,
        deviceType: null,
        inventoryId: null
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenResult, reportsInfo.id]);

  useEffect(() => {

    if(tokenResult.role !== "NORMAL") {
      selKeywordUser('').then(response => {
        const options = response?.map(item => ({
          key: item.id,
          value: item.id,
          label: item.adverName
        }));

        setAdverList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...options
        ]);
      })
    } else {
      setSelectedAdver(tokenResult.id);
    }
  }, []);

  useEffect(() => {
    if(selectedAdver == null) return;
    if(selectedAdver === undefined) return;
    if(selectedAdver === '') return;

    if(tokenResult.role !== "NORMAL") {
      selKeywordAdminCampaign(selectedAdver, '').then(response => {
        const options = response?.map(item => ({
          key: item.id,
          value: item.id,
          label: item.campName
        }));

        setCampaignList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...options
        ]);
      })
    } else {
      selKeywordCampaign(selectedAdver, '').then(response => {
        const options = response?.map(item => ({
          key: item.id,
          value: item.id,
          label: item.campName
        }));

        setCampaignList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...options
        ]);
      })
    }
  }, [selectedAdver]);

  useEffect(() => {
    if(!selectedAdverCamp.length) return;

    if(tokenResult.role !== "NORMAL") {
      Promise.all(selectedAdverCamp.map(selInventoryByAdminCampaign)).then(responses => {
        const inventoryMap = new Map();
        responses.flat().filter(Boolean).forEach(item => {
          inventoryMap.set(item.inventoryId, {
            key: item.inventoryId,
            value: item.inventoryId,
            label: item.inventoryName
          });
        });

        setInventoryList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...inventoryMap.values()
        ]);
      })
    }
  }, [selectedAdverCamp]);

  useEffect(() => {
    makeChartInfo(campaignData);
  }, [campaignData]);

  useEffect(() => {
    makeChartData();
  }, [chartDataInfo, chartData]);

  const sortedCampaignData = useMemo(() => {
    return [...(campaignData || [])].sort((a, b) => {
      if (!a.statisticsDate && !b.statisticsDate) return 0;
      if (!a.statisticsDate) return 1;
      if (!b.statisticsDate) return -1;

      return b.statisticsDate.localeCompare(a.statisticsDate);
    });
  }, [campaignData]);
  const dailyTotalSummary = useMemo(() => {
    const totals = (campaignData || []).reduce((result, item) => ({
      exposureCount: result.exposureCount + (Number(item?.exposureCount) || 0),
      costAmount: result.costAmount + (Number(item?.costAmount) || 0)
    }), {exposureCount: 0, costAmount: 0});

    return {
      ...totals,
      cpv: totals.exposureCount > 0 ? (totals.costAmount / totals.exposureCount) * 1000 : 0
    };
  }, [campaignData]);
  const yFormatted = (id, value) => {
    if (['clickRate', 'conversionRate', 'sessionRoas', 'directRoas', 'totalRoas'].includes(id)) {
      return numberToFixedFormat(value) + '%';
    }

    if ([
      'validClickCount',
      'exposureCount',
      'totalConversionCount',
      'userCount',
      'totalExposureCount',
      'totalClickCount',
      'allowInventorys'
    ].includes(id)) {
      return decimalFormat(value);
    }

    return moneyToFixedFormat(value) + '원';
  };

  const handleChartMetricToggle = (metricId) => {
    setChartData(current => {
      const selectedMetricCount = Object.keys(reportChartMetrics)
        .filter(id => current[id]?.status).length;

      if (current[metricId]?.status && selectedMetricCount === 1) return current;

      return {
        ...current,
        [metricId]: {
          ...current[metricId],
          status: !current[metricId]?.status
        }
      };
    });
  };
  function _toYmd(d) {
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  function _parseToDate(v) {
    if (!v) return null
    // 'YYYY-MM-DD' 또는 Date 모두 대응
    if (v instanceof Date) return v
    return new Date(String(v).slice(0, 10))
  }
  function fillMissingDailyRows(rows, searchCondition) {

    const src = Array.isArray(rows) ? rows : []
    if (src.length === 0) return src

    const key = 'statisticsDate'
    const from = _parseToDate(searchCondition?.searchStartDate)
    const to = _parseToDate(searchCondition?.searchEndDate)

    let minD = from
    let maxD = to

    if (!minD || !maxD) {
      const dates = src
      .map(r => _parseToDate(r?.[key]))
      .filter(Boolean)
      .sort((a, b) => a - b)

      minD = minD || dates[0]
      maxD = maxD || dates[dates.length - 1]
    }

    if (!minD || !maxD) return src

    // ✅ 합산 대상 필드(원본 + 파생지표 포함 가능)
    const sumFields = [
      'exposureCount',
      'totalExposureCount',
      'validClickCount',
      'totalClickCount',
      'sessionConversionCount',
      'directConversionCount',
      'exposureConversionCount',
      'totalConversionCount',
      'costAmount',
      'sessionConversionAmount',
      'directConversionAmount',
      'exposureConversionAmount',
      'totalConversionAmount',
      // 파생지표를 rows에 이미 넣어놨다면, 여기 합산은 비추천(재계산이 맞음)
      // 'clickRate', 'cpc', ...
    ]

    const byYmd = new Map()

    // ✅ 같은 날짜면 누적 합산
    for (const r of src) {
      const d = _parseToDate(r?.[key])
      if (!d) continue
      const ymd = _toYmd(d)

      const prev = byYmd.get(ymd)
      if (!prev) {
        const base = {
          ...r,
          [key]: ymd,
        };

        for (const f of sumFields) {
          base[f] = Number(base[f] ?? 0);
        }

        byYmd.set(ymd, base);
        continue;
      }

      // 누적
      for (const f of sumFields) {
        prev[f] = Number(prev[f] ?? 0) + Number(r?.[f] ?? 0)
      }

      const seen = new Set();
    }

    const out = []
    for (let d = new Date(minD); d <= maxD; d.setDate(d.getDate() + 1)) {
      const ymd = _toYmd(d)
      const hit = byYmd.get(ymd)

      if (hit) {
        out.push(hit)
      } else {
        out.push({
          [key]: ymd,
          exposureCount: 0,
          totalExposureCount: 0,
          validClickCount: 0,
          totalClickCount: 0,
          sessionConversionCount: 0,
          directConversionCount: 0,
          exposureConversionCount: 0,
          totalConversionCount: 0,
          costAmount: 0,
          sessionConversionAmount: 0,
          directConversionAmount: 0,
          exposureConversionAmount: 0,
          totalConversionAmount: 0,
        })
      }
    }

    return out
  }

  const makeChartInfo = (overviewCache) => {
    let data = overviewCache  ?? [];

    const filled = fillMissingDailyRows(data, searchCondition);

    const computed = filled.map(item => {
      const exposureCount = item.exposureCount ?? 0
      const validClickCount = item.validClickCount ?? 0
      const costAmount = item.costAmount ?? 0
      const totalConversionCount = item.totalConversionCount ?? 0
      const totalConversionAmount = item.totalConversionAmount ?? 0
      const sessionConversionAmount = item.sessionConversionAmount ?? 0
      const directConversionAmount = item.directConversionAmount ?? 0
      return {
        ...item,
        clickRate: exposureCount !== 0 ? (validClickCount / exposureCount) * 100 : 0,
        cpc: validClickCount !== 0 ? costAmount / validClickCount : 0,
        costPerConversion: totalConversionCount !== 0 ? costAmount / totalConversionCount : 0,
        avgConversionAmount: totalConversionCount !== 0 ? totalConversionAmount / totalConversionCount : 0,
        sessionRoas: costAmount !== 0 ? (sessionConversionAmount / costAmount) * 100 : 0,
        directRoas: costAmount !== 0 ? (directConversionAmount / costAmount) * 100 : 0,
        totalRoas: costAmount !== 0 ? (totalConversionAmount / costAmount) * 100 : 0,
        ecpm: exposureCount !== 0 ? (costAmount / exposureCount) * 1000 : 0,
        conversionRate: validClickCount !== 0 ? (totalConversionCount / validClickCount) * 100 : 0,
      }
    });
    setChartDataInfo(computed)
  }

  const fixedColors = [
    KPI_CHART_COLORS.exposureCount,
    KPI_CHART_COLORS.costAmount,
    KPI_CHART_COLORS.cpv,
    KPI_CHART_COLORS.allowInventorys,
    '#e66a7a'
  ];
  const makeChartData = () => {
    const activeKeys = Object.keys(chartData).filter(id => chartData[id].status);

    const list = chartDataInfo.map(item => {
      const date = new Date(item?.statisticsDate);
      const formattedDate = dateFormat(date, 'MM/DD');

      const row = {
        date: formattedDate,
        tooltipDate: dateFormat(date, 'YYYY.MM.DD'),
      };

      activeKeys.forEach(id => {
        row[id] = isNaN(Number(item[id])) ? 0 : Number(item[id]);
      });

      return row;
    });

    setChartList(list);
  };
  /**
   * 날짜 직접 변경
   */
  const handleChangeDate = (date) => {
    setDateRange(date)
    if(date[1] !== null){
      setSearchCondition({
        ...searchCondition,
        searchStartDate: moment(date[0]).format('YYYY-MM-DD'),
        searchEndDate: moment(date[1]).format('YYYY-MM-DD'),
      })
    }
  }
  /**
   * 날짜 레인지 선택
   * @param rangeType
   */
  const handleRangeDate = (rangeType) => {
    setDateActive(rangeType)
    if (rangeType === 'thisMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getThisMonth().endDay,
        pageSize: 31
      })
      setDateRange([new Date(getThisMonth().startDay), new Date(getThisMonth().endDay)])
    } else if (rangeType === 'lastMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastMonth().startDay,
        searchEndDate: getLastMonth().endDay,
        pageSize: 31,
      })
      setDateRange([new Date(getLastMonth().startDay), new Date(getLastMonth().endDay)])
    } else if (rangeType === 'today') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getToDay(),
        searchEndDate: getToDay(),
        pageSize: 1
      })
      setDateRange([new Date(), new Date()])
    } else if (rangeType === 'lastDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastDay(),
        searchEndDate: getLastDay(),
        pageSize: 1
      })
      setDateRange([new Date(getLastDay()), new Date(getLastDay())])
    } else if (rangeType === 'lastWeekDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastWeekDay().startDay,
        searchEndDate: getLastWeekDay().endDay,
        pageSize: 7
      })
      setDateRange([new Date(getLastWeekDay().startDay), new Date(getLastWeekDay().endDay)])
    } else if (rangeType === 'lastThirtyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastThirtyDay().startDay,
        searchEndDate: getLastThirtyDay().endDay,
        pageSize: 30
      })
      setDateRange([new Date(getLastThirtyDay().startDay), new Date(getLastThirtyDay().endDay)])
    } else if (rangeType === 'lastNinetyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastNinetyDay().startDay,
        searchEndDate: getLastNinetyDay().endDay,
        pageSize: 90
      })
      setDateRange([new Date(getLastNinetyDay().startDay), new Date(getLastNinetyDay().endDay)])
    }
    //call 때려
  }
  /**
   * 광고상품
   * @param event
   */
  const handleChangeProduct = (event) => {
    setSearchCondition({
      ...searchCondition,
      productType: event.value
    })
  }
  /**
   * 디바이스 서치
   * @param event
   */
  const handleChangeDevice = (event) => {
    console.log(event.value)
    setSearchCondition({
      ...searchCondition,
      deviceType: event.value
    })
  }

  /**
   * 광고주 선택
   * @param event
   */
  const handleSelectAdver = (event) => {
    setSelectedAdver(event.value);
    setSelectedAdverCamp([]);
    setSelectedInventory([]);
    setCampaignList([{
      key: 0,
      value: '',
      label: '전체'
    }]);
    setInventoryList([{
      key: 0,
      value: '',
      label: '전체'
    }]);
    setSearchCondition(current => ({
      ...current,
      inventoryId: null
    }));
  }

  /**
   * 캠페인 선택
   * @param event
   */
  const handleSelectAdverCamp = (options) => {
    const selectedOptions = options || [];
    setSelectedAdverCamp(selectedOptions.some(option => option.value === '')
      ? []
      : selectedOptions.map(option => option.value));
    setSelectedInventory([]);
    setInventoryList([{
      key: 0,
      value: '',
      label: '전체'
    }]);
    setSearchCondition(current => ({
      ...current,
      inventoryId: null
    }));
  }

  /**
   * 지면 선택
   * @param event
   */
  const handleSelectMediaInven = (options) => {
    const selectedOptions = options || [];
    const inventoryIds = selectedOptions.map(option => option.value);
    setSelectedInventory(inventoryIds);
    setSearchCondition(current => ({
      ...current,
      inventoryId: inventoryIds.length ? inventoryIds.join(',') : null
    }));
  }
  /**
   * 검색
   */
  const handleSearchReports = () => {
    const requestCondition = {
      ...searchCondition,
      productType: searchCondition.productType || null,
      deviceType: searchCondition.deviceType || null,
      inventoryId: searchCondition.inventoryId || null
    };

    const applySearchResult = (response) => {
      const content = response?.pagingCommonResponse?.content;
      setCampaignData(Array.isArray(content) ? content : []);
    };

    if(tokenResult.role !== "NORMAL") {
      if(selectedAdver !== '') {
        if(selectedAdverCamp.length){
          retrieveCommonReportsAdminDetailByAdverCampId(tokenResult.id, requestCondition, 'campaign_daily', selectedAdver, selectedAdverCamp.join(','))
          .then(applySearchResult)
        } else {
          retrieveCommonReportsAdminDetailByAdverId(tokenResult.id, requestCondition, 'adver_daily', selectedAdver, '')
          .then(applySearchResult)
        }
      } else {
        retrieveCommonReportsAdminDetail(tokenResult.id, requestCondition, 'period')
        .then(applySearchResult)
      }
    }else {

      if(selectedAdverCamp.length) {
        retrieveCommonReportsDetailByAdverCampId(tokenResult.id, requestCondition, 'campaign_daily', selectedAdverCamp.join(','))
        .then(applySearchResult)
      } else {
        retrieveCommonReportsDetail(tokenResult.id, requestCondition, 'period')
        .then(applySearchResult)
      }
    }
  }

  return(<PeriodReportPage>
    <ReportCard $condition>
      <PlatformSectionHeader
          title="조회 조건"
          description="광고주, 캠페인, 지면, 광고 상품, 디바이스와 기간을 기준으로 일자별 데이터를 조회합니다."
          collapsible
          open={isConditionOpen}
          onToggle={() => setIsConditionOpen(open => !open)}
          action={<ReportConditionSummary items={[
            ...(tokenResult?.role !== 'NORMAL' ? [{label:'광고주', value:adverList.find(item => item.value === selectedAdver)?.label || '전체'}] : []),
            {label:'캠페인', value:selectedAdverCamp.length ? campaignList.filter(item => selectedAdverCamp.includes(item.value)).map(item => item.label).join(', ') : '전체'},
            ...(tokenResult?.role !== 'NORMAL' ? [{label:'지면', value:selectedInventory.length ? inventoryList.filter(item => selectedInventory.includes(item.value)).map(item => item.label).join(', ') : '전체'}] : []),
            {label:'상품', value:productType.find(item => item.value === searchCondition.productType)?.label || '전체'},
            {label:'디바이스', value:deviceType.find(item => item.value === searchCondition.deviceType)?.label || '전체'},
            {label:'기간', value:`${searchCondition.searchStartDate} ~ ${searchCondition.searchEndDate}`}
          ]}/>} 
      />
        {isConditionOpen && <ConditionBody>
        <BoardSearchDetail>
          <ReportFilterGrid>
            {
              (tokenResult?.role !== "NORMAL") &&
              <ReportFilterItem>
                <ColTitle><span>광고주</span></ColTitle>
                <ReportSelect options={adverList}
                        className="period-report-select"
                        defaultValue={adverList[0]}
                        value={adverList.find(item => item.value === selectedAdver)}
                        onChange={handleSelectAdver}
                        isSearchable={false}
                />
              </ReportFilterItem>
            }
            <ReportFilterItem>
              <ColTitle><span>캠페인</span></ColTitle>
              <FilterCheckboxDropdown
                  disabled={selectedAdver === '' || selectedAdver === null}
                  options={campaignList}
                  selectedValues={selectedAdverCamp}
                  onChange={handleSelectAdverCamp}
                  itemName="캠페인"
                  searchPlaceholder="캠페인명 검색"
              />
            </ReportFilterItem>
            {tokenResult?.role !== "NORMAL" &&
              <ReportFilterItem>
                <ColTitle><span>지면</span></ColTitle>
                <FilterCheckboxDropdown
                    disabled={!selectedAdverCamp.length}
                    options={inventoryList}
                    selectedValues={selectedInventory}
                    onChange={handleSelectMediaInven}
                    itemName="지면"
                    searchPlaceholder="지면명 검색"
                />
              </ReportFilterItem>
            }
          </ReportFilterGrid>
          <ReportFilterGrid>
            <ReportFilterItem>
              <ColTitle><span>광고 상품</span></ColTitle>
              <ReportSelect options={productType}
                      className="period-report-select"
                      defaultValue={productType[0]}
                      value={productType.find(item => item.value === searchCondition.productType)}
                      onChange={handleChangeProduct}
                      isSearchable={false}
              />
              {/*<ReportSelect styles={selectStyle} defaultValue={productType[0]} options={productType} onChange={handleChangeProduct} value={productType.find(item => item.value === searchCondition.productType)}/>*/}
            </ReportFilterItem>
            <ReportFilterItem>
              <ColTitle><span>디바이스</span></ColTitle>
              <ReportSelect options={deviceType}
                      className="period-report-select"
                      defaultValue={deviceType[0]}
                      value={deviceType.find(item => item.value === searchCondition.deviceType)}
                      onChange={handleChangeDevice}
                      isSearchable={false}
              />
              {/*<div style={{width: '100px'}}>*/}
              {/*  <ReportSelect styles={selectStyle} defaultValue={deviceType[0]} options={deviceType} onChange={handleChangeDevice} value={deviceType.find(item => item.value === searchCondition.deviceType)}/>*/}
              {/*</div>*/}
            </ReportFilterItem>
          </ReportFilterGrid>
          <PeriodFilterGrid>
            <ReportFilterItem>
              <ColTitle><span>기간</span></ColTitle>
              <DateContainer>
                <CalendarBox>
                  <CalendarIcon/>
                </CalendarBox>
                <CustomDatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(date) => handleChangeDate(date)}
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  locale={ko}
                  isClearable={false}
                  monthsShown={2}
                  openToDate={startDate}
                  focusSelectedMonth
                  calendarContainer={props => <ReportCalendarContainer {...props} active={dateActive} onSelect={handleRangeDate}/>} 
                />
              </DateContainer>
            </ReportFilterItem>
            <QuickPeriodItem>
              <RangePicker>
                <div onClick={() => handleRangeDate('thisMonth')} style={dateActive==='thisMonth'?{color:mainColor, fontWeight:"bold"}:null}>이번달</div>
                <HorizontalRule style={{margin: "0 10px"}}/>
                <div onClick={() => handleRangeDate('lastMonth')} style={dateActive==='lastMonth'?{color:mainColor, fontWeight:"bold"}:null}>지난달</div>
                <HorizontalRule style={{margin: "0 10px"}}/>
                <div onClick={() => handleRangeDate('today')} style={dateActive==='today'?{color: mainColor, fontWeight:"bold"}:null}>오늘</div>
                <HorizontalRule style={{margin: "0 10px"}}/>
                <div onClick={() => handleRangeDate('lastDay')} style={dateActive==='lastDay'?{color:mainColor, fontWeight:"bold"}:null}>어제</div>
                <HorizontalRule style={{margin: "0 10px"}}/>
                <div onClick={() => handleRangeDate('lastWeekDay')} style={dateActive==='lastWeekDay'?{color:mainColor, fontWeight:"bold"}:null}>지난7일</div>
                <HorizontalRule style={{margin: "0 10px"}}/>
                <div onClick={() => handleRangeDate('lastThirtyDay')} style={dateActive==='lastThirtyDay'?{color:mainColor, fontWeight:"bold"}:null}>지난30일</div>
                <HorizontalRule style={{margin: "0 10px"}}/>
                <div onClick={() => handleRangeDate('lastNinetyDay')} style={dateActive==='lastNinetyDay'?{color:mainColor, fontWeight:"bold"}:null}>지난90일</div>
              </RangePicker>
            </QuickPeriodItem>
            <ReportConditionActions onReset={handleResetReports} onApply={handleSearchReports}/>
          </PeriodFilterGrid>
              {/*<ValidationGroup>*/}
              {/*  <DefaultButton onClick={handleSearchReports}>검색</DefaultButton>*/}
              {/*</ValidationGroup>*/}
      </BoardSearchDetail>
        </ConditionBody>}
    </ReportCard>
    <ReportCard>
        <ChartBody>
        <ChartMetricHeader>
          <ChartMetricGuide>
            <strong>차트 지표</strong>
            <span>확인할 지표를 선택하면 차트에 바로 반영됩니다.</span>
          </ChartMetricGuide>
          <DailySummaryGrid>
          <DailySummaryCard $compact $color={KPI_CHART_COLORS.exposureCount}>
            <DailySummaryIcon $color={KPI_CHART_COLORS.exposureCount}>노출</DailySummaryIcon>
            <DailySummaryContent><span>총 노출수</span><strong>{decimalFormat(dailyTotalSummary.exposureCount)}</strong><small>건</small></DailySummaryContent>
          </DailySummaryCard>
          <DailySummaryCard $compact $color={KPI_CHART_COLORS.costAmount}>
            <DailySummaryIcon $color={KPI_CHART_COLORS.costAmount}>비용</DailySummaryIcon>
            <DailySummaryContent><span>총 비용</span><strong>{moneyToFixedFormat(dailyTotalSummary.costAmount)}</strong><small>원</small></DailySummaryContent>
          </DailySummaryCard>
          <DailySummaryCard $compact $color={KPI_CHART_COLORS.cpv}>
            <DailySummaryIcon $color={KPI_CHART_COLORS.cpv}>CPV</DailySummaryIcon>
            <DailySummaryContent><span>CPV</span><strong>{moneyToFixedFormat(dailyTotalSummary.cpv)}</strong><small>원</small></DailySummaryContent>
          </DailySummaryCard>
        </DailySummaryGrid>
        </ChartMetricHeader>
        <ChartMetricOptions>
          {Object.entries(reportChartMetrics).map(([id, metric]) => {
            const isSelected = Boolean(chartData[id]?.status);

            return (
                <ChartMetricButton
                    key={id}
                    type="button"
                    $selected={isSelected}
                    $color={metric.color}
                    aria-pressed={isSelected}
                    onClick={() => handleChartMetricToggle(id)}
                >
                  <ChartMetricCheck $selected={isSelected} $color={metric.color}/>
                  <ChartMetricText>
                    <strong>{chartData[id]?.label}</strong>
                  </ChartMetricText>
                </ChartMetricButton>
            );
          })}
        </ChartMetricOptions>
        <ChartContainer>
          <div style={{height: 300}}>
            {chartList.length !== 0 &&
                <ResponsiveBar
                    data={chartList}
                    keys={Object.keys(chartData).filter(id => chartData[id].status)}
                    indexBy="date"
                    margin={{ top: 20, right: 30, bottom: 50, left: 70 }}
                    padding={0.3}
                    groupMode="grouped"
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    colors={({id}) => reportChartMetrics[id]?.color || '#94a3b8'}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: -45,
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      format: value => decimalFormat(value),
                    }}
                    enableLabel={false}
                    tooltip={({ id, value, color, data }) => {
                      return (
                          <ChartTooltip>
                            <p className={'date'}>{data.tooltipDate}</p>
                            <p>
            <span style={{ color }}>
              {chartData[id]?.label} :
            </span>
                              <span>{yFormatted(id, value)}</span>
                            </p>
                          </ChartTooltip>
                      );
                    }}
                    legends={[]}
                    role="application"
                />
            }
          </div>
        </ChartContainer>
        </ChartBody>
    </ReportCard>
    <ReportCard>
      <PlatformSectionHeader
          title="일자별 데이터"
          description="조회 조건에 해당하는 일자별 상세 성과 데이터를 확인합니다."
          action={<ExcelHeaderButton type="button" onClick={() => setDownloadTrigger(trigger => trigger + 1)}>엑셀 저장</ExcelHeaderButton>}
      />
      <TableBody>
      <BoardSearchResult>
        <Table
          style={{fontSize: 15, minHeight: campaignData?.length !== 0 ? 420 : 220}}
          headerHeight={40}
          downloadList={false}
          downloadTrigger={downloadTrigger}
          lockedRows={lockedReportRows}
          summaryReducer={summaryReportReducer}
          columns={campaignColumn}
          data={sortedCampaignData}
          fileName={'일자별_보고서'}
          defaultSortInfo={{field:"statisticsDate", dir: -1}}
          enableColumnAutosize={true}
          idProperty={'statisticsDate'}
        />
      </BoardSearchResult>
      </TableBody>
    </ReportCard></PeriodReportPage>
  )
}

const PeriodReportPage = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

const ReportCard = styled.section`
  position: relative;
  z-index: ${({$condition}) => $condition ? 10 : 1};
  overflow: ${({$condition}) => $condition ? 'visible' : 'hidden'};
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, 0.045);
`;

const ReportFilterGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 18px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

const ReportFilterItem = styled.div`
  display: block;
  width: 100%;
  min-width: 0;

  > ${ColTitle} {
    width: auto;
    min-width: 0;
    margin-bottom: 8px;
    padding: 0;
  }

  > .period-report-select {
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
  }
`;

const FilterCheckboxContainer = styled.div`
  position: relative;
  width: 100%;
`;

const FilterCheckboxTrigger = styled.button`
  display: flex;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 0 11px;
  border: 1px solid ${({$open}) => $open ? '#f5811f' : '#e5e5e5'};
  border-radius: 6px;
  background: ${({disabled}) => disabled ? '#f5f5f5' : '#fff'};
  color: ${({disabled}) => disabled ? '#aaa' : '#444'};
  font-family: inherit;
  font-size: var(--font-size-13);
  text-align: left;
  cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};

  &:hover { border-color: ${({disabled}) => disabled ? '#e5e5e5' : '#f1d4c2'}; }
  &:focus-visible { outline: 2px solid rgba(245, 129, 31, .2); outline-offset: 1px; }
  > span:first-child {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
`;

const FilterDropdownArrow = styled.span`
  flex: 0 0 auto;
  color: #888;
  font-size: var(--font-size-16);
  transform: ${({$open}) => $open ? 'rotate(180deg)' : 'none'};
  transition: transform .15s ease;
`;

const FilterCheckboxMenu = styled.div`
  position: absolute;
  z-index: 40;
  top: calc(100% + 5px);
  right: 0;
  left: 0;
  overflow: hidden;
  box-sizing: border-box;
  padding: 7px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .12);
`;

const FilterSearchInput = styled.input`
  width: 100%;
  height: 34px;
  box-sizing: border-box;
  margin-bottom: 6px;
  padding: 0 10px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  color: #444;
  font-family: inherit;
  font-size: var(--font-size-12);
  outline: none;

  &:focus {border-color:#f5811f;box-shadow:0 0 0 2px rgba(245,129,31,.1);}
`;

const FilterCheckboxList = styled.div`
  max-height: 220px;
  overflow-y: auto;
  border-top: 1px solid #f0f0f0;
  padding-top: 4px;
`;

const FilterCheckboxOption = styled.label`
  display: flex;
  width: 100%;
  min-height: 34px;
  box-sizing: border-box;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 0;
  border-radius: 5px;
  background: #fff;
  color: #555;
  font-family: inherit;
  font-size: var(--font-size-12);
  text-align: left;
  cursor: pointer;

  &:hover {background:#fff7f0;color:#d96500;}
  input {width:15px;height:15px;flex:0 0 15px;margin:0;accent-color:#f5811f;pointer-events:none;}
  strong {font-weight:700;}
  span {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
`;

const FilterEmptyOption = styled.div`
  padding: 14px 8px;
  color: #999;
  font-size: var(--font-size-12);
  text-align: center;
`;

const PeriodFilterGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: minmax(250px, 1fr);
  align-items: end;
  gap: 18px;

  @media (max-width: 1050px) {
    grid-template-columns: minmax(230px, 1fr) minmax(0, 2fr);
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const QuickPeriodItem = styled(ReportFilterItem)`
  display: none;
  ${RangePicker} {
    display: flex;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    margin: 0;
    padding: 4px 6px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background: #fff;
    overflow-x: auto;
  }

  ${RangePicker} > div:empty { display: none; }
  ${RangePicker} > div:not(:empty) {
    display:inline-flex;height:30px;flex:0 0 auto;align-items:center;justify-content:center;
    box-sizing:border-box;padding:0 10px;border:1px solid transparent;border-radius:5px;
    background:#fff;color:#737b83;cursor:pointer;white-space:nowrap;transition:.14s ease;
  }
  ${RangePicker} > div:not(:empty):hover {border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
  ${RangePicker} > div:not(:empty)[style*="font-weight"] {border-color:#f1d4c2;background:#fff4e8;color:#f5811f !important;}
`;

const PeriodActionItem = styled.div`
  display: flex;
  height: 40px;
  align-items: stretch;

  @media (max-width: 1050px) {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }

  @media (max-width: 720px) {
    grid-column: auto;

    > button {
      width: 100%;
    }
  }
`;

const ConditionBody = styled.div`

  ${BoardSearchDetail} {
    display: flex;
    flex-direction: column;
    gap: 14px;
    background: #fff;
  }

  ${RowSpan} {
    align-items: center;
    margin-top: 0;
    padding: 0;
  }

  ${ColTitle} {
    min-width: 76px;
    color: #555;
    font-size: var(--font-size-13);
    font-weight: 700;
  }

  .period-report-select {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    flex: 1 1 auto !important;
  }

  ${GraySearchButton} {
    min-width: 82px;
    height: 40px;
    border: 1px solid #f5811f;
    border-radius: 6px;
    background: #f5811f;
    color: #fff;
    font-size: var(--font-size-13);
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 3px 8px rgba(245, 129, 31, 0.18);

    &:hover {
      border-color: #e87213;
      background: #e87213;
    }
  }

  ${DateContainer} {
    width: 360px;
    max-width: 100%;
    height: 42px;
    min-height: 42px;
    overflow: visible;
    border: 1px solid #dfe3e6;
    border-radius: 8px;
    background: #fff;
    transition: border-color .14s ease, box-shadow .14s ease;
  }

  ${DateContainer}:hover { border-color: #f1d4c2; }
  ${DateContainer}:focus-within {
    border-color: #f5811f;
    box-shadow: 0 0 0 3px rgba(245,129,31,.13);
  }

  ${CalendarBox} {
    width: 42px;
    min-width: 42px;
    min-height: 40px;
    border-right: 1px solid #f1e4da;
    border-radius: 7px 0 0 7px;
    background: #fff8f1;
  }

  ${CalendarIcon} {
    width: 16px;
    height: 18px;
    background-size: 16px 18px;
    opacity: .82;
  }

  ${DateContainer} .react-datepicker-wrapper,
  ${DateContainer} .react-datepicker__input-container {
    width: 100%;
    height: 40px;
  }

  ${DateContainer} input[type='text'] {
    width: 100%;
    height: 40px !important;
    box-sizing: border-box;
    padding: 0 12px !important;
    border: 0 !important;
    border-radius: 0 7px 7px 0;
    background: #fff !important;
    color: #444;
    font-size: var(--font-size-13) !important;
    font-weight: 600;
    cursor: pointer;
    box-shadow: none !important;
  }

  ${DateContainer} .react-datepicker {
    overflow: hidden;
    border: 1px solid #e5e8eb;
    border-radius: 9px;
    box-shadow: 0 10px 28px rgba(31,41,55,.14);
    font-size: var(--font-size-13);
  }

  ${DateContainer} .react-datepicker__header {
    border-bottom-color: #f1e4da;
    background: #fff8f1;
  }

  ${DateContainer} .react-datepicker__day--selected,
  ${DateContainer} .react-datepicker__day--in-range {
    background: #f5811f;
    color: #fff;
  }

  ${DateContainer} .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range) {
    background: transparent;
    color: inherit;
  }

  ${RangePicker} {
    color: #737b83;
    font-size: var(--font-size-12);
  }

  @media (max-width: 900px) {
    .period-report-select {
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      flex-basis: auto !important;
    }

    ${RowSpan} {
      align-items: stretch;
      flex-direction: column;
      gap: 10px;
    }

    ${ColSpan1}, ${ColSpan2} {
      width: 100%;
      padding-left: 0;
    }
  }
`;

const ChartBody = styled.div`
  padding: 18px 20px 20px;
  background: #fff;

  ${ChartContainer} {
    overflow: hidden;
    border: 0;
    border-radius: 0;
    background: transparent;
  }
`;

const ChartMetricHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;

  @media (max-width: 900px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const ChartMetricGuide = styled.div`
  display: flex;
  min-width: 190px;
  flex-direction: column;
  gap: 4px;

  strong {
    color: #2f3438;
    font-size: var(--font-size-15);
    font-weight: 700;
  }

  span {
    color: #8b929a;
    font-size: var(--font-size-12);
    line-height: 1.4;
  }
`;

const ChartMetricOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin: 14px 0 2px;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    width: 100%;
    justify-content: flex-start;
  }

`;

const ChartMetricButton = styled.button`
  display: inline-flex;
  height: 30px;
  align-items: center;
  gap: 7px;
  padding: 0 8px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #444;
  text-align: left;
  cursor: pointer;
  opacity: ${({$selected}) => $selected ? 1 : .4};
  transition: background-color .15s ease, opacity .15s ease;

  &:hover {
    background: #f7f8f9;
    opacity: 1;
  }

  &:focus-visible {
    outline: 1px solid #f5811f;
    outline-offset: 2px;
  }
`;

const ChartMetricCheck = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  flex: 0 0 8px;
  box-sizing: border-box;
  border: 2px solid ${({$color}) => $color};
  border-radius: 2px;
  background: ${({$selected, $color}) => $selected ? $color : '#fff'};
`;

const ChartMetricText = styled.span`
  display: inline-flex;
  min-width: 0;

  strong {
    color: #444;
    font-size: var(--font-size-13);
    font-weight: 600;
  }
`;

const TableBody = styled.div`
  padding: 10px 12px 12px;
  background: #fff;

  ${BoardSearchResult} {
    margin: 0;
    padding: 0;
    border: 0;
    background: #fff;
  }

  && .InovuaReactDataGrid {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
`;

const DailySummaryGrid = styled.div`
  display: grid;
  min-width: 430px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 0;

  @media (max-width: 900px) {
    min-width: 0;
    width: 100%;
  }
`;

const DailySummaryCard = styled.div`
  display: flex;
  min-width: 0;
  min-height: 48px;
  box-sizing: border-box;
  align-items: center;
  gap: 7px;
  padding: 7px 9px;
  border: 1px solid ${({$color}) => `${$color}26`};
  border-radius: 9px;
  background: ${({$color}) => `${$color}08`};
`;

const DailySummaryIcon = styled.span`
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: ${({$color}) => `${$color}18`};
  color: ${({$color}) => $color};
  font-size: var(--font-size-10);
  font-weight: 800;
`;

const DailySummaryContent = styled.div`
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 3px;
  flex-wrap: wrap;

  > span {
    width: 100%;
    margin-bottom: 1px;
    color: #858d95;
    font-size: var(--font-size-10);
  }

  > strong {
    overflow: hidden;
    color: #343a40;
    font-size: var(--font-size-14);
    font-weight: 800;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > small {
    color: #9299a0;
    font-size: var(--font-size-10);
  }
`;

const ExcelHeaderButton = styled.button`
  display: inline-flex;
  min-width: 88px;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border: 1px solid #d7e5d9;
  border-radius: 6px;
  background: #f7fbf7;
  color: #47774d;
  font-size: var(--font-size-12);
  font-weight: 700;
  cursor: pointer;

  &:hover {
    border-color: #bcd6c0;
    background: #eef7ef;
  }
`;
